import { render, staticRenderFns } from "./LogoImageView.vue?vue&type=template&id=39070882&"
import script from "./LogoImageView.vue?vue&type=script&lang=js&"
export * from "./LogoImageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports